import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'tutorial-animation',
    templateUrl: './tutorial-animation.component.html',
    styleUrls: ['./tutorial-animation.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class TutorialAnimation implements OnInit {

    public readonly icon: string = 'sh-tutorial';
    public activeStateIdx: number = 0;
    public states: State[] = [State.motes, State.user, State.story, State.unlock, State.tours, State.route, State.collection, State.browse];

    constructor() { }

    ngOnInit(): void {
    }

    public goToNextState() {
        if(this.activeStateIdx >= this.states.length) return;
        this.activeStateIdx++;
    }
}

export enum State {
    motes = "motes",
    user = "user",
    story = "story",
    unlock = "unlock",
    tours = "tours",
    route = "route",
    collection = "collection",
    browse = "browse"
}
